/* eslint-disable react/jsx-props-no-spreading */
import cx from 'classnames';
import styles from './Panel.module.less';
import { useDialogHide, useCommandPalette, useAutoFocusInput } from './hooks';
import Input from './SearchInput';
import NoResults from './NoResults';
import Results from './Results';
import LinkResult from './LinkResult';

type Props = {
  onHide: () => void
  isOpen: boolean;
};

/**
 * The main panel component for the velocity search.
 * This component is responsible for rendering the input field
 * and the search results.
 */
const Panel = ({ onHide, isOpen } : Props) => {
  const mainRef = useDialogHide(onHide);
  const inputRef = useAutoFocusInput(isOpen);
  const {
    items,
    getInputProps,
    getMenuProps,
    getItemProps,
    highlightedIndex,
    hasNoResults,
  } = useCommandPalette(onHide);

  return (
    <div className={cx(styles.backdrop, 'animated fast fadeIn')}>
      <div
        ref={mainRef}
        role="dialog"
        aria-modal="true"
        className={cx(styles.main, 'animated fast fadeInUp')}
      >
        <Input {...getInputProps()} inputRef={inputRef} />
        {hasNoResults && <NoResults />}
        <Results {...getMenuProps()}>
          {items.map((result, index: number) => (
            <LinkResult
              key={result.label}
              {...getItemProps({
                item: result,
                index,
              })}
              to="#"
              label={result.label}
              isHighlighted={highlightedIndex === index}
            />
          ))}
        </Results>
      </div>
    </div>
  );
};

export default Panel;
